// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__19slQ","author":"Table_author__2V14P","authorImage":"Table_authorImage__2mXds","unreadRow":"Table_unreadRow__3i3BO"};